(function(){
"use strict";
var PROJECT_URL="https://ycentdpkspjdrzijrbsl.supabase.co";
var API_KEY="sb_publishable_TgKotXn3vvPpdnad_wXc9g_X1DY7arT";
var STORAGE_KEY="sb-ycentdpkspjdrzijrbsl-auth-token";
var PENDING_KEY="kp-pending-join-code-v1";
var AUTOJOIN_KEY="kp-auto-join-code-v1";
var scanner=null,busy=false,managerBusy=false;
var authDraft={email:"",password:""};

function token(){
  try{var v=JSON.parse(localStorage.getItem(STORAGE_KEY)||"null");return v&&v.access_token?v.access_token:null;}catch(e){return null;}
}
function esc(v){return String(v==null?"":v).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#039;");}
function baseHash(){return location.hash.split("?")[0];}
function queryCode(){
  try{
    var q=location.hash.split("?")[1]||"";
    return cleanCode(new URLSearchParams(q).get("code")||"");
  }catch(e){return "";}
}
function cleanCode(v){return String(v||"").toUpperCase().replace(/[^A-Z0-9]/g,"").slice(0,12);}
function joinUrl(code){
  var u=new URL(location.origin+location.pathname);
  var ctx=window.KP_THEME_CONTEXT||{};
  if(ctx.role&&ctx.role!=="main"&&ctx.id){
    u.searchParams.set("preview_theme_id",String(ctx.id));
  }
  u.hash="/join?code="+encodeURIComponent(code);
  return u.origin+u.pathname+(u.search?u.search:"")+u.hash;
}
async function rpc(name,body,authRequired){
  var headers={"apikey":API_KEY,"Content-Type":"application/json"};
  var t=token();
  if(t)headers.Authorization="Bearer "+t;
  if(authRequired&&!t)throw new Error("Du behöver logga in först.");
  var r=await fetch(PROJECT_URL+"/rest/v1/rpc/"+name,{method:"POST",headers:headers,body:JSON.stringify(body||{})});
  if(!r.ok){
    var m="";try{var j=await r.json();m=j.message||j.error||"";}catch(e){}
    throw new Error(m||"Något gick fel.");
  }
  return await r.json();
}
function setStatus(msg,type){
  var e=document.getElementById("kp-join-status");if(!e)return;
  e.textContent=msg||"";e.className="kp-join-status"+(type?" "+type:"");
}
function extractCode(raw){
  var s=String(raw||"").trim();
  var direct=cleanCode(s);
  if(direct.length===6)return direct;
  try{
    var u=new URL(s);
    var hash=u.hash||"";
    var q=hash.indexOf("?")>=0?hash.slice(hash.indexOf("?")+1):u.search.slice(1);
    var c=cleanCode(new URLSearchParams(q).get("code")||"");
    if(c)return c;
  }catch(e){}
  var m=s.match(/(?:code=|join[:/])([A-Z0-9]{6,12})/i);
  return m?cleanCode(m[1]):"";
}
function app(){return document.getElementById("app");}
function stopScanner(){
  if(scanner){try{scanner.stop();scanner.destroy();}catch(e){}scanner=null;}
}
function nav(hash){stopScanner();location.hash=hash;}
function renderJoin(){
  if(baseHash()!=="#/join")return;
  stopScanner();
  var root=app();if(!root)return;
  var code=queryCode();
  root.innerHTML='<main class="kp-join-page" data-kp-join-page="1"><div class="kp-join-shell">'+
    '<div class="kp-join-top"><div style="display:flex;align-items:center;gap:.8rem"><a class="kp-login-back-home" href="#/">← <span>Till startsidan</span></a><a class="kp-join-brand" href="#/">Kampansera.</a></div><a class="btn btn-ghost btn-sm" href="#/login">Logga in</a></div>'+
    '<section class="kp-join-card"><div class="kp-join-hero"><div class="kp-join-icon">👥</div><h1>Joina klass</h1><p>Scanna klassens QR-kod eller skriv in gruppkoden. Du kan hitta gruppen innan du loggar in.</p></div>'+
      '<div class="kp-join-tabs"><button type="button" class="kp-join-tab active" data-join-tab="code">Skriv kod</button><button type="button" class="kp-join-tab" data-join-tab="scan">Scanna QR</button></div>'+
      '<div id="kp-join-code-panel" class="kp-join-panel"><div class="kp-join-field"><label for="kp-join-code">Gruppkod</label><input id="kp-join-code" maxlength="12" autocomplete="off" placeholder="ABC123" value="'+esc(code)+'"></div><button type="button" id="kp-join-check" class="btn btn-primary btn-block">Hitta klassen</button><div class="kp-join-note">Koden finns på klassens Kampansera-QR eller hos gruppansvarig.</div></div>'+
      '<div id="kp-join-scan-panel" class="kp-join-panel" hidden><div class="kp-join-camera"><video id="kp-join-video" playsinline muted></video></div><button type="button" id="kp-join-start-camera" class="btn btn-primary btn-block">Starta kamera</button><div class="kp-join-camera-note">Kameran används bara för att läsa QR-koden och ingen video sparas.</div></div>'+
      '<div id="kp-join-preview-host"></div><div id="kp-join-status" class="kp-join-status"></div>'+
    '</section></div></main>';
  bindJoin();
  if(code)preview(code,true);
}
function bindJoin(){
  document.querySelectorAll("[data-join-tab]").forEach(function(b){b.onclick=function(){
    document.querySelectorAll("[data-join-tab]").forEach(function(x){x.classList.remove("active");});
    b.classList.add("active");
    var scan=b.dataset.joinTab==="scan";
    document.getElementById("kp-join-code-panel").hidden=scan;
    document.getElementById("kp-join-scan-panel").hidden=!scan;
    if(!scan)stopScanner();
  };});
  var inp=document.getElementById("kp-join-code");
  inp.addEventListener("input",function(){inp.value=cleanCode(inp.value);});
  inp.addEventListener("keydown",function(e){if(e.key==="Enter"){e.preventDefault();preview(inp.value);}});
  document.getElementById("kp-join-check").onclick=function(){preview(inp.value);};
  document.getElementById("kp-join-start-camera").onclick=startCamera;
}
async function preview(code,autoContinue){
  code=cleanCode(code);
  if(code.length<4){setStatus("Skriv en giltig gruppkod.","err");return;}
  setStatus("Letar efter klassen…","");
  var host=document.getElementById("kp-join-preview-host");if(host)host.innerHTML="";
  try{
    var d=await rpc("get_invite_preview",{p_code:code},false);
    if(!d||!d.valid){setStatus("Koden är ogiltig, utgången eller redan full.","err");return;}
    localStorage.setItem(PENDING_KEY,code);
    if(autoContinue)localStorage.setItem(AUTOJOIN_KEY,code);
    if(autoContinue&&!token()){
      if(host)host.innerHTML='<div class="kp-join-preview"><b>'+esc(d.group_name||"Grupp")+'</b><span>'+esc(d.group_type||"klass")+' · kod '+esc(code)+'</span></div>';
      setStatus("Klassen hittades ✓ Du skickas till skapa konto…","ok");
      setTimeout(function(){nav("/register");},450);
      return;
    }
    if(host)host.innerHTML='<div class="kp-join-preview"><b>'+esc(d.group_name||"Grupp")+'</b><span>'+esc(d.group_type||"klass")+' · kod '+esc(code)+'</span></div>'+
      '<div class="kp-join-actions mt-2">'+
        (token()
          ? '<button type="button" class="btn btn-primary" id="kp-join-confirm">Gå med i klassen</button><button type="button" class="btn btn-ghost" id="kp-join-cancel">Avbryt</button>'
          : '<button type="button" class="btn btn-primary" id="kp-join-register">Skapa konto och fortsätt</button><button type="button" class="btn btn-ghost" id="kp-join-login">Jag har redan konto</button>')+
      '</div>';
    setStatus("Klassen hittades ✓","ok");
    var c=document.getElementById("kp-join-confirm");if(c)c.onclick=function(){joinNow(code,d.group_name||"gruppen");};
    var x=document.getElementById("kp-join-cancel");if(x)x.onclick=function(){localStorage.removeItem(PENDING_KEY);nav("/");};
    var l=document.getElementById("kp-join-login");if(l)l.onclick=function(){nav("/login");};
    var reg=document.getElementById("kp-join-register");if(reg)reg.onclick=function(){nav("/register");};
    if(token()&&cleanCode(localStorage.getItem(AUTOJOIN_KEY)||"")===code){
      localStorage.removeItem(AUTOJOIN_KEY);
      setTimeout(function(){joinNow(code,d.group_name||"gruppen",true);},100);
    }
  }catch(e){setStatus(e.message||"Kunde inte kontrollera koden.","err");}
}
async function joinNow(code,groupName,autoContinue){
  if(busy)return;busy=true;setStatus("Skickar din förfrågan…","");
  var b=document.getElementById("kp-join-confirm");if(b)b.disabled=true;
  try{
    var out=await rpc("join_group_by_code",{p_code:code},true);
    localStorage.removeItem(PENDING_KEY);
    var host=document.getElementById("kp-join-preview-host");
    if(host)host.innerHTML='<div class="kp-join-preview"><b>'+(out&&out.joined?"Förfrågan skickad ✓":"Du är redan kopplad till gruppen")+'</b><span>'+esc(out&&out.group_name||groupName)+'. '+(out&&out.joined?"Gruppansvarig kan nu godkänna dig.":"Du kan gå vidare till gruppsidan.")+'</span></div><div class="kp-join-actions mt-2"><button type="button" class="btn btn-primary" id="kp-join-go-group">Till gruppen</button></div>';
    var g=document.getElementById("kp-join-go-group");if(g)g.onclick=function(){nav("/group");};
    if(autoContinue){
      setStatus("Du är ansluten till klassen ✓","ok");
      setTimeout(function(){
        history.replaceState(null,"",location.pathname+location.search+"#/group");
        location.reload();
      },350);
      return;
    }
    setStatus("","");
  }catch(e){setStatus(e.message||"Kunde inte gå med i gruppen.","err");if(b)b.disabled=false;}
  finally{busy=false;}
}
async function startCamera(){
  var btn=document.getElementById("kp-join-start-camera");
  if(scanner){stopScanner();btn.textContent="Starta kamera";return;}
  if(!(window.QrScanner&&typeof window.QrScanner==="function")){setStatus("QR-scannern kunde inte starta. Använd gruppkoden istället.","err");return;}
  var video=document.getElementById("kp-join-video");
  btn.disabled=true;setStatus("Startar kameran…","");
  try{
    scanner=new window.QrScanner(video,function(result){
      var raw=result&&result.data?result.data:String(result||"");
      var code=extractCode(raw);
      if(!code)return;
      stopScanner();
      var inp=document.getElementById("kp-join-code");if(inp)inp.value=code;
      document.querySelectorAll("[data-join-tab]").forEach(function(x){x.classList.toggle("active",x.dataset.joinTab==="code");});
      document.getElementById("kp-join-code-panel").hidden=false;
      document.getElementById("kp-join-scan-panel").hidden=true;
      preview(code,true);
    },{preferredCamera:"environment",highlightScanRegion:true,highlightCodeOutline:true,returnDetailedScanResult:true});
    await scanner.start();btn.textContent="Stoppa kamera";setStatus("Rikta kameran mot klassens QR-kod.","");
  }catch(e){stopScanner();setStatus("Kameran kunde inte starta. Kontrollera kamerabehörigheten eller skriv gruppkoden.","err");}
  finally{btn.disabled=false;}
}
function bindAuthDraftHandoff(){
  var r=baseHash();
  if(r!=="#/login"&&r!=="#/register")return;
  var email=document.getElementById("email");
  var password=document.getElementById("password");
  if(r==="#/register"){
    if(email&&!email.value&&authDraft.email){
      email.value=authDraft.email;
      email.dispatchEvent(new Event("input",{bubbles:true}));
    }
    if(password&&!password.value&&authDraft.password){
      password.value=authDraft.password;
      password.dispatchEvent(new Event("input",{bubbles:true}));
    }
  }
}
document.addEventListener("click",function(e){
  var link=e.target.closest&&e.target.closest('a[href]');
  if(!link||baseHash()!=="#/login")return;
  var href=link.getAttribute("href")||"";
  if(href!=="#/register")return;
  var email=document.getElementById("email");
  var password=document.getElementById("password");
  authDraft.email=email?email.value:"";
  authDraft.password=password?password.value:"";
},true);
function injectAuthBackAndJoin(){
  var r=baseHash();
  if(r!=="#/login"&&r!=="#/register")return;

  var forms=document.querySelectorAll("form");
  var form=null;
  for(var i=0;i<forms.length;i++){if(forms[i].querySelector('input[type="password"]')){form=forms[i];break;}}
  if(!form)return;

  if(!document.getElementById("kp-login-back-home")){
    var back=document.createElement("a");
    back.id="kp-login-back-home";
    back.className="kp-login-back-home";
    back.href="#/";
    back.innerHTML='← <span>Till startsidan</span>';
    var right=document.querySelector(".auth-right");
    if(right) right.insertBefore(back,right.firstChild);
    else form.insertAdjacentElement("beforebegin",back);
  }

  if(r!=="#/login"||document.getElementById("kp-join-login-extra"))return;
  var box=document.createElement("div");box.id="kp-join-login-extra";box.className="kp-join-login-extra";
  box.innerHTML='<div class="kp-join-divider">eller</div><a href="#/join" class="btn btn-ghost btn-block">👥 Joina klass</a>';
  form.insertAdjacentElement("afterend",box);
}
function injectLandingJoin(){
  if(baseHash()!=="#/"&&baseHash()!=="")return;
  if(document.getElementById("kp-join-landing-btn"))return;
  var cta=document.querySelector(".lp-nav-cta");if(!cta)return;
  var a=document.createElement("a");a.id="kp-join-landing-btn";a.href="#/join";a.className="btn btn-ghost btn-sm";a.textContent="Joina klass";
  cta.insertBefore(a,cta.firstChild);
}
async function drawInviteQr(canvas,url,width){
  if(!canvas)return false;
  try{
    await window.QRCode.toCanvas(canvas,url,{width:width||260,margin:4,errorCorrectionLevel:"M",color:{dark:"#14162B",light:"#FFFFFF"}});
    canvas.style.imageRendering="pixelated";
    if(typeof window.jsQR==="function"){
      var ctx=canvas.getContext("2d",{willReadFrequently:true});
      var img=ctx.getImageData(0,0,canvas.width,canvas.height);
      var decoded=window.jsQR(img.data,canvas.width,canvas.height,{inversionAttempts:"attemptBoth"});
      return !!(decoded&&decoded.data&&extractCode(decoded.data));
    }
    return true;
  }catch(e){return false;}
}
async function openInviteQrModal(url,code){
  var old=document.getElementById("kp-class-qr-modal");if(old)old.remove();
  var overlay=document.createElement("div");
  overlay.id="kp-class-qr-modal";
  overlay.setAttribute("role","dialog");
  overlay.setAttribute("aria-modal","true");
  overlay.setAttribute("aria-label","Förstorad klass-QR");
  overlay.style.cssText="position:fixed;inset:0;z-index:2147483000;background:rgba(20,22,43,.72);display:flex;align-items:center;justify-content:center;padding:20px;";
  overlay.innerHTML='<div style="width:min(520px,94vw);max-height:94vh;overflow:auto;background:#fff;border-radius:22px;padding:18px;box-shadow:0 24px 80px rgba(0,0,0,.28);text-align:center">'+
    '<div style="display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:12px"><div style="text-align:left"><strong style="display:block;font-size:1.05rem">Klass-QR</strong><span style="font-size:.86rem;color:#606579">Kod '+esc(code)+'</span></div><button type="button" id="kp-class-qr-modal-close" class="btn btn-ghost btn-sm" aria-label="Stäng förstorad QR">Stäng</button></div>'+
    '<div style="background:#fff;border:1px solid #ececf2;border-radius:18px;padding:16px;display:flex;justify-content:center"><canvas id="kp-class-qr-modal-canvas" style="display:block;width:min(420px,78vw);height:auto;max-width:100%"></canvas></div>'+
    '<p style="margin:12px 0 0;font-size:.88rem;color:#606579">Rikta mobilkameran mot QR-koden.</p>'+
  '</div>';
  document.body.appendChild(overlay);
  var close=function(){document.removeEventListener("keydown",onKey);if(overlay&&overlay.isConnected)overlay.remove();};
  var onKey=function(e){if(e.key==="Escape")close();};
  document.addEventListener("keydown",onKey);
  overlay.addEventListener("click",function(e){if(e.target===overlay)close();});
  document.getElementById("kp-class-qr-modal-close").onclick=close;
  await drawInviteQr(document.getElementById("kp-class-qr-modal-canvas"),url,420);
}
async function injectManagerInvite(){
  if(baseHash()!=="#/group"||managerBusy||document.getElementById("kp-class-invite-card"))return;
  var content=document.querySelector(".content");if(!content)return;
  managerBusy=true;
  try{
    var mgr=await rpc("get_group_payment_settings_v1",{p_group_id:null},true);
    if(!mgr||!mgr.has_group)return;
    var inv=await rpc("create_group_invite_v27",{p_group_id:mgr.group_id,p_require_approval:true,p_max_uses:40,p_rotate:false},true);
    if(!inv||!inv.code)return;
    if(baseHash()!=="#/group"||document.getElementById("kp-class-invite-card"))return;
    var card=document.createElement("section");card.id="kp-class-invite-card";card.className="kp-class-invite-card";
    var url=joinUrl(inv.code);
    card.innerHTML='<div class="kp-class-invite-head"><div><h3>Bjud in till klassen</h3><p>Elever kan scanna QR-koden eller skriva gruppkoden. Nya medlemmar väntar på ditt godkännande.</p></div><span class="badge badge-brand">Klass-QR</span></div>'+
      '<div class="kp-class-invite-body"><div class="kp-class-invite-qr"><canvas id="kp-class-invite-qr"></canvas></div><div><div class="kp-class-code">'+esc(inv.code)+'</div><div class="kp-class-invite-meta">Användningar: '+esc(inv.use_count||0)+' / '+esc(inv.max_uses||40)+' · Den här QR-koden är endast för att joina gruppen, inte för kundbeställningar.</div><div class="kp-class-invite-actions"><button type="button" class="btn btn-ghost btn-sm" id="kp-enlarge-class-qr">Förstora QR</button><button type="button" class="btn btn-ghost btn-sm" id="kp-copy-class-code">Kopiera kod</button><button type="button" class="btn btn-ghost btn-sm" id="kp-copy-class-link">Kopiera länk</button></div><div id="kp-class-qr-status" class="kp-class-invite-meta"></div></div></div>';
    content.appendChild(card);
    var qrCanvas=document.getElementById("kp-class-invite-qr");
    var ok=await drawInviteQr(qrCanvas,url);
    var st=document.getElementById("kp-class-qr-status");if(st)st.textContent=ok?"QR-koden är självtestad och läsbar ✓ · Tryck på QR-koden för att förstora":"QR kunde inte verifieras – dela koden istället.";
    var enlarge=function(){openInviteQrModal(url,inv.code);};
    if(qrCanvas){qrCanvas.style.cursor="zoom-in";qrCanvas.setAttribute("title","Förstora QR-koden");qrCanvas.onclick=enlarge;}
    var eq=document.getElementById("kp-enlarge-class-qr");if(eq)eq.onclick=enlarge;
    var cc=document.getElementById("kp-copy-class-code");if(cc)cc.onclick=function(){navigator.clipboard.writeText(inv.code);cc.textContent="Kopierad ✓";};
    var cl=document.getElementById("kp-copy-class-link");if(cl)cl.onclick=function(){navigator.clipboard.writeText(url);cl.textContent="Kopierad ✓";};
  }catch(e){}finally{managerBusy=false;}
}
function resumePending(){
  var code=cleanCode(localStorage.getItem(PENDING_KEY)||"");
  if(!code||!token())return;
  var r=baseHash();
  if(r==="#/join")return;
  if(r==="#/login"||r==="#/register"||r==="#/dashboard"||r==="#/group"||r==="#/"){
    var u=new URL(location.href);
    u.hash="/join?code="+encodeURIComponent(code);
    location.replace(u.toString());
    location.reload();
  }
}
function sync(){
  var r=baseHash();
  if(r==="#/join"){var root=app();if(root&&!root.querySelector("[data-kp-join-page]"))renderJoin();}
  else stopScanner();
  if(r==="#/login"||r==="#/register"){injectAuthBackAndJoin();bindAuthDraftHandoff();}
  if(r==="#/"||r==="")injectLandingJoin();
  if(r==="#/group")injectManagerInvite();
  resumePending();
}
window.addEventListener("hashchange",function(){setTimeout(sync,120);});
window.addEventListener("focus",function(){setTimeout(sync,120);});
var a=app();if(a&&window.MutationObserver)new MutationObserver(function(){setTimeout(sync,80);}).observe(a,{childList:true,subtree:true});
setInterval(resumePending,1200);
setTimeout(sync,500);
})();